import React from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
} from "@mui/material";

const Loading = () => {
  return (
    <Grid container justifyContent={"center"}>
      <Paper sx={{ padding: "15px", width: "100%", mt: 2 }}>
        <TableContainer
          sx={{ marginTop: 2, maxHeight: 560, overflowY: "auto" }}
        >
          <Table>
            <TableHead sx={{ bgcolor: "#f5f5f5" }}>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Full Name</TableCell>
                <TableCell>Contact</TableCell>
                <TableCell>Procedure</TableCell>
                <TableCell>Procedure Date</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Price</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody sx={{ bgcolor: "#ccfcfc" }}>
              {Array.from(new Array(5)).map((_, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Skeleton width="50px" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="100px" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="80px" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="150px" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="120px" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="80px" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="80px" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="40px" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="80px" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Grid>
  );
};

export default Loading;
